export default __webpack_public_path__ + "static/energie-si-resurse-label-6be7635ce442f3305cb7f9d1e61a9ac1.png";